import { render, staticRenderFns } from "./PrivilegeInfoOverAll.vue?vue&type=template&id=2b473906&"
import script from "./PrivilegeInfoOverAll.vue?vue&type=script&lang=js&"
export * from "./PrivilegeInfoOverAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports